// extracted by mini-css-extract-plugin
module.exports = {"nameOfCategory":"_2t39ehNmL0yjP-jFlY8_C8","fieldsWrapper":"_1QWu5Tb0y4icNMFIZ0L3hu","row":"_2715JxZqDOhVZuvEx0H7wS","mainProps":"_2UMlvSibV96e7dw-YKqRLR"};